<template>
    <div class="waitlist-other-products">
        <p>{{ $t('WaitlistOtherProducts.text') }}</p>

        <div class="text-center">
            <nuxt-link class="btn btn-primary btn-lg mx-auto" to="/">
                {{ $t('WaitlistOtherProducts.otherProductsButton') }}
            </nuxt-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WaitlistOtherProducts'
};
</script>
